import { useRef } from 'react';
import Image from 'next/image';
import { motion, useInView } from 'framer-motion';

import eight from './headshots/eight.png';
import five from './headshots/five.png';
import four from './headshots/four.png';
import one from './headshots/one.png';
import seven from './headshots/seven.png';
import six from './headshots/six.png';
import three from './headshots/three.png';
import two from './headshots/two.png';

const buildTransition = (delay: number) => ({
  duration: 1.2,
  delay: delay + 0.15,
  ease: [0.25, 0.1, 0.25, 1],
});

const finalState = {
  opacity: 1,
  scale: 1,
  filter: 'blur(0px)',
};

export const Headshots = () => {
  const ref = useRef<HTMLDivElement>(null);
  const inView = useInView(ref, { once: true, amount: 0.3 });
  return (
    <section className="bg-cipher-04 relative overflow-hidden ml:pt-100 ml:pb-120 pb-80 ml:px-30">
      <div className="max-w-[1450px] mx-auto px-30 relative ml:py-350 py-300">
        {/* Central text block */}
        <div
          ref={ref}
          className="relative z-10 max-w-[288px] m:max-w-[400px] ml:max-w-[690px] mx-auto"
        >
          <p className="ml:text-[32px] m:text-[24px] text-[16px] font-light leading-[133%] tracking-[-0.32px] text-center text-cloud text-pretty">
            Our customers built AI-ready foundations, unlocked new revenue
            opportunities, and honored consent, preference, and privacy choices
            for billions of users worldwide.
          </p>
        </div>

        <div className="absolute inset-0 top-0">
          <motion.div
            className="absolute right-60 ml:right-0 l:w-180 w-130 m:w-150 l:top-130 top-110"
            initial={{ opacity: 0, scale: 0.3, filter: 'blur(10px)' }}
            animate={
              inView
                ? finalState
                : { opacity: 0, scale: 0.3, filter: 'blur(10px)' }
            }
            transition={buildTransition(0)}
          >
            <Image src={one} alt="one" className="w-full h-full object-cover" />
          </motion.div>

          <motion.div
            className="absolute bottom-0 right-[30vw] lx:right-[220px] w-293 hidden ml:block"
            initial={{ opacity: 0, scale: 0.7, filter: 'blur(10px)' }}
            animate={
              inView
                ? finalState
                : { opacity: 0, scale: 0.7, filter: 'blur(10px)' }
            }
            transition={buildTransition(0.1)}
          >
            <Image src={two} alt="two" className="w-full h-full object-cover" />
          </motion.div>

          <motion.div
            className="absolute top-40 w-120 m:w-160 left-20 l:top-140 l:w-122 ml:hidden lx:block l:left-[500px] "
            initial={{ opacity: 0, scale: 0.8, filter: 'blur(10px)' }}
            animate={
              inView
                ? finalState
                : { opacity: 0, scale: 0.8, filter: 'blur(10px)' }
            }
            transition={buildTransition(0.2)}
          >
            <Image
              src={three}
              alt="three"
              className="w-full h-full object-cover"
            />
          </motion.div>

          <motion.div
            className="absolute aspect-square w-185 bottom-20 left-[390px] hidden lx:block"
            initial={{ opacity: 0, scale: 0.8, filter: 'blur(10px)' }}
            animate={
              inView
                ? finalState
                : { opacity: 0, scale: 0.8, filter: 'blur(10px)' }
            }
            transition={buildTransition(0.3)}
          >
            <Image
              src={four}
              alt="four"
              className="w-full h-full object-cover"
            />
          </motion.div>

          <motion.div
            className="absolute ml:top-50 bottom-0 ml:bottom-auto lx:left-200 l:left-40 right-40 ml:right-auto ml:w-173 w-130 m:w-170"
            initial={{ opacity: 0, scale: 0.8, filter: 'blur(10px)' }}
            animate={
              inView
                ? finalState
                : { opacity: 0, scale: 0.8, filter: 'blur(10px)' }
            }
            transition={buildTransition(0.4)}
          >
            <Image
              src={five}
              alt="five"
              className="w-full h-full object-cover"
            />
          </motion.div>

          <motion.div
            className="absolute bottom-60 w-200 lx:w-262 hidden ml:block"
            initial={{ opacity: 0, scale: 0.8, filter: 'blur(10px)' }}
            animate={
              inView
                ? finalState
                : { opacity: 0, scale: 0.8, filter: 'blur(10px)' }
            }
            transition={buildTransition(0.5)}
          >
            <Image src={six} alt="six" className="w-full h-full object-cover" />
          </motion.div>

          <motion.div
            className="absolute ml:w-240 w-140 m:w-170 bottom-70 ml:top-0 ml:bottom-auto ml:right-[30vw] lx:right-[270px] left-20 ml:left-auto "
            initial={{ opacity: 0, scale: 0.8, filter: 'blur(10px)' }}
            animate={
              inView
                ? finalState
                : { opacity: 0, scale: 0.8, filter: 'blur(10px)' }
            }
            transition={buildTransition(0.6)}
          >
            <Image
              src={seven}
              alt="seven"
              className="w-full h-full object-cover"
            />
          </motion.div>

          <motion.div
            className="absolute bottom-100 right-0 w-145 hidden ml:block"
            initial={{ opacity: 0, scale: 0.8, filter: 'blur(10px)' }}
            animate={
              inView
                ? finalState
                : { opacity: 0, scale: 0.8, filter: 'blur(10px)' }
            }
            transition={buildTransition(0.7)}
          >
            <Image
              src={eight}
              alt="eight"
              className="w-full h-full object-cover"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};
